import {Injectable} from '@angular/core';
/**
 * Created by Sergey Shoshin on 2017-04-22.
 */

@Injectable()
export class DeviceService {
    public getMac() {
        return 'webplayer';
    }
}


// WEBPACK FOOTER //
// ./src/app/services/device-service.ts